import { Button, Form, Input, Select } from 'antd';

import React, { useEffect, useState } from 'react';
import { getUserList } from '../../../api/user';
import TrendModal from '../../../components/modal/TrendModal';
import BasicSelect from '../../../components/select/BasicSelect';
import { SORT_OPTIONS } from '../../alarm-history/contand';
import {
  DEFAULT_PAGINATION_LIMIT,
  DEFAULT_PAGINATION_PAGE,
} from '../../logs/contand';
import DateFilter from '../../plant-analysis/DateFilter';
import moment from 'jalali-moment';
import useCalendar from '../../../hooks/useCalendar';

function AlarmManagementHistoryModal(props) {
  const { state, setState, form, handleGetAlarmManagementHistoryData } = props;
  const calendar = useCalendar();
  const [status, setStatus] = useState([]);
  const category = [
    { label: 'MINOR', value: 'MINOR' },
    { label: 'MAJOR', value: 'MAJOR' },
    { label: 'EVENT', value: 'EVENT' },
  ];
  useEffect(() => {
    handleGetUsers();
    form.setFieldsValue({
      sort: 'DESC',
    });
  }, []);


  const handleGetUsers = async () => {
    try {
      const { data } = await getUserList();

      const statusList = data?.result?.UsersList?.map((param) => {
        return {
          label: param.username,
          value: param.username,
        };
      });

      setStatus(statusList);
    } catch (error) {
      console.log(error);
    }
  };

  const onSelectChange = (value, name) => {
    setState({
      ...state,
      [name]: value,
    });
  };

  const handleSubmit = (values) => {
    // Equipment
    // const items = {
    //   ...state.info,
    //   limit: DEFAULT_PAGINATION_LIMIT,
    //   page: DEFAULT_PAGINATION_PAGE,
    //   equipmentTitle: state.deviceId ? state.deviceId : '',
    //   type: state.equipmentId,
    //   sort: values.sort,
    //   startDate:
    //     state?.startDate == undefined
    //       ? state?.info?.startDate
    //       : state?.startDate,
    //   endDate:
    //     state?.endDate == undefined ? state?.info?.endDate : state?.endDate,
    // };
    // if (values?.status !== undefined && values?.status !== '') {
    //   items.status = +values.status;
    // } else {
    //   delete items.status;
    // }
    const items = {
      startDate: calendar
        ? moment(state?.startDate || state?.info?.startDate, 'jYYYY/jMM/jDD')
            .locale('en')
            .startOf('day')
            .format('YYYY-MM-DDTHH:mm:ss.SSSZ')
        : state?.startDate || state?.info?.startDate,
    endDate: calendar
        ? moment(state?.endDate || state?.info?.endDate, 'jYYYY/jMM/jDD')
            .locale('en')
            .endOf('day')
            .format('YYYY-MM-DDTHH:mm:ss.SSSZ')
        : state?.endDate || state?.info?.endDate,
      title: values.title,
      username: values.username,
      sort: values.sort,
      limit: DEFAULT_PAGINATION_LIMIT,
      page: DEFAULT_PAGINATION_PAGE,
    };
    if (values.title == '') {
      delete items.title;
    }
    console.log(values);
    setState({
      ...state,
      info: items,
      submit: true,
    });
    // handleGetAlarmManagementHistoryData(items);
  };
  return (
    <TrendModal
      show={state.showFilterModal}
      width={330}
      onCancel={() => setState({ ...state, showFilterModal: false })}
      hasBtn
    >
      <Form
        name="basic"
        form={form}
        labelWrap={false}
        className="text-xs flex flex-col items-center font-bold "
        onFinish={handleSubmit}
        layout="vertical"
        requiredMark="optional"
        // initialValues={{
        //   type: state.info.type,
        //   equipmentTitle: state.info.equipmentTitle,
        //   ...(state.info?.status !== undefined && {
        //     status: +state.info?.status,
        //   }),
        // }}
        autoComplete="off"
      >
        <div className=" flex flex-col items-start gap-1 w-full pt-3 px-3">
          <DateFilter
            state={state}
            setState={setState}
            logFilter
            historyFilter
          />
        </div>

        {/* <div className="mb-4 w-full bg-red-300"> */}
        <Form.Item name="title" label="Write title" className="w-[230px]">
          <Input
            allowClear
            showSearch
            className="bg-[#EEF0F2] text-[#5B6268] rounded-lg border-none "
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>
        <Form.Item
          name="username"
          label="Select username"
          className="w-[230px]"
        >
          <Select
            allowClear
            showSearch
            className="bg-[#EEF0F2] text-[#5B6268] rounded-lg border-none "
            options={status}
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>
        <BasicSelect
          allowclear={true}
          showSearch={true}
          label="Category"
          name="Category"
          // onSelectChange={(e) => onSelectChange(e, 'status')}
          options={category}
          width="230px"
        />
        {/* </div> */}
        <BasicSelect
          label="Sort"
          name="sort"
          // onSelectChange={(e) => onSelectChange(e, 'sort')}
          options={SORT_OPTIONS}
          width="230px"
        />
        <Button
          loading={state.loading}
          htmlType="submit"
          className={`rounded-xl mt-5 text-center w-44 h-9 text-xs text-white bg-[#6E6FF7] `}
        >
          Add Parameters
        </Button>
      </Form>
    </TrendModal>
  );
}

export default AlarmManagementHistoryModal;
